import type { SmartViewWidget } from "../../../../../../api/types/dashboardsTypes.ts";
import type { TabularReportConfigurationForRunning } from "../../../../../../api/types/svTypes.ts";
import type { DrillDownArgs } from "../DrillDownArgs.ts";
import SmartViewTabularContainer from "./SmartViewTabularContainer";

interface Props {
  widget: SmartViewWidget;
  data: TabularReportConfigurationForRunning;
  onDrillDown: (args: DrillDownArgs) => void;
}

const SmartViewTabularWidget = ({ data, widget, onDrillDown }: Props) => {
  return <SmartViewTabularContainer data={data} widget={widget} onDrillDown={onDrillDown} />;
};

export default SmartViewTabularWidget;
